import React from 'react';
import PropTypes from 'prop-types'; 
import {Image,Button} from 'react-bootstrap';

const itemStates = {
  false: "+",
  true: "-"
}

class MayLikeItem extends React.Component {
	constructor(props) {
    super(props);
    this.state = {
      chosen: false,
      itemState: itemStates[false]
    }

    this.changeStyle = this.changeStyle.bind(this);
    this.onClick = this.onClick.bind(this);
  }
  
  componentDidMount() {
    if (this.props.changeStyle) {
      this.props.changeStyle(this, this.changeStyle);
    }
  }

  changeStyle(state) {
    const itemState = itemStates[state];
    
    // Change style of button

    this.setState({
      chosen: state,
      itemState: itemState
    });
  }

  onClick(e) {
    let chooseState = !this.state.chosen;
    this.props.onAdd(this, chooseState);
  }
  
  render() {
    	return (
        <div className="item">
          <div className={"position-relative " + this.props.boxClass}>
            <Button onClick={(e) => {this.onClick(e)}} className="btn btn-primary btn-sm position-absolute"> {this.state.itemState} </Button>
            <Image src={this.props.image} className={this.props.imageClass} alt={this.props.imageAlt} />
            {
              this.props.title ? <h6>{this.props.title}</h6> : ""
            }
            {
              this.props.price ? <small>{this.props.price}</small> : ""
            }
          </div>
        </div>
		);
	}
}

MayLikeItem.propTypes = {
  onAdd: PropTypes.func.isRequired,
  image: PropTypes.string.isRequired,
  imageClass: PropTypes.string,
  imageAlt: PropTypes.string,
  boxClass: PropTypes.string,
  title: PropTypes.string,
  price: PropTypes.string,
};
MayLikeItem.defaultProps = {
  	imageAlt:'',
    image:'',
    imageClass:'',
    boxClass:'mall-category-item',
    title:'',
    price:'',
    onAdd: () => {}
}

export default MayLikeItem;